import { render, staticRenderFns } from "./SpecialDays.vue?vue&type=template&id=42457ca4&scoped=true&"
import script from "./SpecialDays.vue?vue&type=script&lang=js&"
export * from "./SpecialDays.vue?vue&type=script&lang=js&"
import style0 from "./SpecialDays.vue?vue&type=style&index=0&id=42457ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42457ca4",
  null
  
)

export default component.exports